import { render } from "./background-images.html?vue&type=template&id=31d73c92&scoped=true&ts=true"
import script from "./background-images.ts?vue&type=script&lang=ts"
export * from "./background-images.ts?vue&type=script&lang=ts"

import "./background-images.scss?vue&type=style&index=0&id=31d73c92&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d73c92"]])

export default __exports__